import React, { Component } from "reactn";
import { Tabs, Tab } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import {
  FamilyProfile,
  PaymentMethod,
  AccountSettings,
  IntProg,
  ApplicationsIcon,
  MyEnroll,
  TourRequests,
  PaymentSettings
} from "../../assets";
import "../../assets/css/componentSpecificCss/NavBarParent.css";

import styles from "./parentNavigationStyles";

class ParentNav extends Component {
  constructor(props) {
    super(props);

    this.sublinks = {
      "/user/family-profile": [
        {
          name: "Family Profile",
          icon: FamilyProfile,
          to: "/user/family-profile"
        },
        {
          name: "Calendar",
          icon: FamilyProfile, //TODO: Icon to be updated to correct one
          to: "/user/calendar" //TODO: Link to be updated to new component route
        }
      ],
      "/user/account-settings": [
        {
          name: "Account Settings",
          icon: AccountSettings,
          to: "/user/account-settings"
        },
        {
          name: "My Orders",
          icon: PaymentMethod,
          to: "/user/orders"
        },
        {
          name: "Credits",
          icon: PaymentMethod,
          to: "/user/credit"
        },
        {
          name: "Payment Settings",
          icon: PaymentMethod,
          to: "/user/payment-settings",
          disabled: "payment"
        }
        // {
        //   name: "Password Reset",
        //   icon: AccountSettings, //TODO: Icon to be updated to correct one
        //   to: "/user" //TODO: Link to be updated to new component route
        // },
        // {
        //   name: "Referrals",
        //   icon: AccountSettings, //TODO: Icon to be updated to correct one
        //   to: "/user" //TODO: Link to be updated to new component route
        // }
      ],
      "/user/interested-programs": [
        {
          name: "Interested Programs",
          icon: IntProg,
          to: "/user/interested-programs/all",
          submenu: [
            { name: "All", to: "/user/interested-programs/all" },
            { name: "Enrolled", to: "/user/interested-programs/enrolled" },
            { name: "Applied", to: "/user/interested-programs/applied" },
            { name: "Saved", to: "/user/interested-programs/saved" },
            { name: "Recommended", to: "/user/interested-programs/recommended" }
          ]
        },
        {
          name: "Appointments",
          icon: TourRequests,
          to: "/user/tour-requests"
        },
        {
          name: "Applications",
          icon: ApplicationsIcon,
          to: "/user/applications"
        }
        // {
        //   name: "Waitlists",
        //   icon: IntProg, //TODO: Icon to be updated to correct one
        //   to: "/user/interested-programs" //TODO: Link to be updated to new component route
        // }
      ],
      "/user/my-enrollments": [
        {
          name: "My Enrollments",
          icon: MyEnroll,
          to: "/user/my-enrollments"
        },
        {
          name: "My Events",
          icon: MyEnroll,
          to: "/user/my-events"
        },
        {
          name: "Gift Cards",
          icon: MyEnroll, //TODO: Icon to be updated to correct one
          to: "/user/gifts" //TODO: Link to be updated to new component route
        },
        {
          name: "Memberships",
          icon: MyEnroll, //TODO: Icon to be updated to correct one
          to: "/user/memberships" //TODO: Link to be updated to new component route
        },
        {
          name: "Forms",
          icon: MyEnroll,
          to: "/user/forms"
        },
        {
          name: "Parties",
          icon: MyEnroll,
          to: "/user/parties"
        }

        // {
        //   name: "News Feed",
        //   icon: PaymentSettings,
        //   to: "/user/newsfeed"
        // }
      ]
    };

    this.state = {
      ...this.getNavigationState(props.location.pathname),
      displayedSubTabs: "",
      selectedSubLink: 0,
      links: [
        {
          name: "Dashboard",
          icon: PaymentSettings,
          to: "/user",
          hideDashboard: 262, // Hiding dashboard for Liz from Alice's program
          hideDashboard2: 578 // 578 Hide dashboard for Roopa from Shanaz's program
        },
        {
          name: "Profile",
          icon: FamilyProfile,
          to: "/user/family-profile"
        },
        {
          name: "My Children",
          icon: FamilyProfile,
          to: "/user/my-children"
        },
        {
          name: "Account",
          icon: AccountSettings,
          to: "/user/account-settings"
        },
        {
          name: "Interests",
          icon: IntProg,
          to: "/user/interested-programs/all"
        },
        {
          name: "Bookings",
          icon: PaymentMethod,
          to: "/user/my-enrollments"
        }
        // {
        //   name: "Messages",
        //   icon: PaymentMethod,
        //   to: "/user/messages"
        // }
      ],
      sublinks: {
        "/user/family-profile": [
          {
            name: "Profile",
            icon: FamilyProfile,
            to: "/user/family-profile"
          },
          {
            name: "Calendar",
            icon: FamilyProfile, //TODO: Icon to be updated to correct one
            to: "/user/calendar" //TODO: Link to be updated to new component route
          }
        ],
        "/user/account-settings": [
          {
            name: "Account Settings",
            icon: AccountSettings,
            to: "/user/account-settings"
          },
          {
            name: "My Orders",
            icon: PaymentMethod,
            to: "/user/orders"
          },
          {
            name: "Credits",
            icon: PaymentMethod,
            to: "/user/credit"
          },
          {
            name: "Payment Settings",
            icon: PaymentMethod,
            to: "/user/payment-settings",
            disabled: "payment"
          }
          // {
          //   name: "Password Reset",
          //   icon: AccountSettings, //TODO: Icon to be updated to correct one
          //   to: "/user/password-reset" //TODO: Link to be updated to new component route
          // },
          // {
          //   name: "Referrals",
          //   icon: AccountSettings, //TODO: Icon to be updated to correct one
          //   to: "/user/referrals" //TODO: Link to be updated to new component route
          // }
        ],
        "/user/interested-programs": [
          {
            name: "Interested Programs",
            icon: IntProg,
            to: "/user/interested-programs/all",
            submenu: [
              { name: "All", to: "/user/interested-programs/all" },
              { name: "Enrolled", to: "/user/interested-programs/enrolled" },
              { name: "Applied", to: "/user/interested-programs/applied" },
              { name: "Saved", to: "/user/interested-programs/saved" },
              { name: "Recommended", to: "/user/interested-programs/recommended" }
            ]
          },
          {
            name: "Appointments",
            icon: TourRequests,
            to: "/user/tour-requests"
          },
          {
            name: "Applications",
            icon: ApplicationsIcon,
            to: "/user/applications"
          }
          // {
          //   name: "Waitlists",
          //   icon: IntProg, //TODO: Icon to be updated to correct one
          //   to: "/user/waitlists" //TODO: Link to be updated to new component route
          // }
        ],
        "/user/my-enrollments": [
          {
            name: "My Enrollments",
            icon: MyEnroll,
            to: "/user/my-enrollments"
          },
          {
            name: "My Events",
            icon: MyEnroll,
            to: "/user/my-events"
          },
          {
            name: "Gift Cards",
            icon: MyEnroll, //TODO: Icon to be updated to correct one
            to: "/user/gifts" //TODO: Link to be updated to new component route
          },
          {
            name: "Memberships",
            icon: MyEnroll, //TODO: Icon to be updated to correct one
            to: "/user/memberships" //TODO: Link to be updated to new component route
          },
          {
            name: "Forms",
            icon: MyEnroll,
            to: "/user/forms"
          },
          {
            name: "Parties",
            icon: MyEnroll,
            to: "/user/parties"
          }

          // {
          //   name: "News Feed",
          //   icon: PaymentSettings,
          //   to: "/user/newsfeed"
          // }
        ]
      }
    };
  }

  /*
  links: [
        {
          name: "Dashboard",
          icon: PaymentSettings,
          to: "/parents"
        },
        {
          name: "Family Profile",
          icon: FamilyProfile,
          to: "/parents/family-profile"
        },
        {
          name: "Payment Settings",
          icon: PaymentMethod,
          to: "/parents/payment-settings",
          disabled: "payment"
        },
        {
          name: "Account Settings",
          icon: AccountSettings,
          to: "/parents/account-settings"
        },
        {
          name: "Interested Programs",
          icon: IntProg,
          to: "/parents/interested-programs"
        },
        {
          name: "Appointments",
          icon: TourRequests,
          to: "/parents/tour-requests"
        },
        {
          name: "Applications",
          icon: ApplicationsIcon,
          to: "/parents/applications"
        },
        {
          name: "My Orders",
          icon: PaymentMethod,
          to: "/parents/orders"
        },
        {
          name: "My Enrollments",
          icon: MyEnroll,
          to: "/parents/my-enrollments"
        },
        {
          name: "News Feed",
          icon: PaymentSettings,
          to: "/parents/newsfeed"
        }
      ], 
  */

  getNavigationState(currentPath) {
    let parentPath = "/user"; // Default to dashboard
    let activeSub = "";
    let activeFilter = "";

    Object.keys(this.sublinks).forEach(parentKey => {
      const matchingSub = this.sublinks[parentKey].find(
        sub =>
          sub.to === currentPath ||
          (sub.submenu && sub.submenu.some(item => item.to === currentPath))
      );
      if (matchingSub || parentKey === currentPath) {
        parentPath = parentKey;
        activeSub = matchingSub
          ? matchingSub.to
          : this.sublinks[parentKey][0].to;
        if (matchingSub && matchingSub.submenu) {
          activeFilter = matchingSub.submenu.some(item => item.to === currentPath)
            ? currentPath
            : matchingSub.submenu[0].to;
        }
      }
    });
    if (
      currentPath.startsWith("/user/my-enrollments/") ||
      currentPath.startsWith("/user/acceptance/") ||
      currentPath.startsWith("/user/welcome/")
    ) {
      parentPath = "/user/my-enrollments";
      activeSub = "/user/my-enrollments";
    }
    if (parentPath === "/user" && currentPath !== "/user") {
      parentPath = currentPath;
    }

    return {
      active: parentPath,
      activeSubLink: activeSub,
      activeSubSubLink: activeFilter,
      displayOrgEnrollment: currentPath.includes(
        "/user/org-enrollments/Program"
      )
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState(this.getNavigationState(this.props.location.pathname));
    }
  }

  render() {
    if (!this.global.dsUser) {
      return null;
    }
    if (this.state.displayOrgEnrollment) {
      return null;
    }
    return (
      <div>
        <Tabs
          value={
            this.state.active === "/user/interested-programs"
              ? "/user/interested-programs/all"
              : this.state.active
          }
          onChange={(event, newValue) => {
            const parentPath = newValue.includes("/user/interested-programs")
              ? "/user/interested-programs"
              : newValue;

            this.setState({
              active: parentPath,
              activeSubSubLink: "",
              activeSubLink: this.sublinks[parentPath]
                ? this.sublinks[parentPath][0].to
                : ""
            });

            this.props.history.push(newValue);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          style={{
            paddingLeft: "10px",
            marginTop: "104px",
            paddingTop: "0px",
            borderBottom: "1px solid gainsboro"
          }}
          TabIndicatorProps={{ className: this.props.classes.tabIndicator }}
        >
          {this.state.links
            .filter(
              l =>
                l.hideDashboard !== this.global.dsUser.id &&
                l.hideDashboard2 !== this.global.dsUser.id
            )
            .map(e => (
              <Tab
                label={e.name}
                value={e.to}
                disableRipple
                disableFocusRipple
                classes={{
                  root: this.props.classes.tabRoot,
                  selected: this.props.classes.tabSelected
                }}
                key={e.to}
              />
            ))}
        </Tabs>

        {this.state.active === "/user/my-children" && <div id="family-section-navigation" />}
        {this.sublinks[this.state.active] && (
          <Tabs
            value={
              this.state.activeSubLink ||
              (this.sublinks[this.state.active]
                ? this.sublinks[this.state.active][0].to
                : "")
            }
            onChange={(event, newValue) => {
              this.setState({ activeSubLink: newValue });
              this.props.history.push(newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{ className: this.props.classes.tabIndicator }}
            classes={{ root: this.props.classes.subHeadings }}
          >
            {this.state.sublinks[this.state.active].map((sublink, i) => {
              if (
                this.global.parentGuardians &&
                sublink.name === "My Children"
              ) {
                if (this.global.parentGuardians.length > 0) {
                  if (!this.global.parentGuardians[0].has_child) {
                    return null;
                  }
                }
              }
              return (
                <Tab
                  label={sublink.name}
                  value={sublink.to}
                  disableRipple
                  disableFocusRipple
                  // TabIndicatorProps={{
                  //   className: this.props.classes.tabIndicator
                  // }}
                  classes={{
                    root: `${this.props.classes.tabRoot} ${this.props.classes.subMenuText}`,
                    selected: this.props.classes.tabSelected
                  }}
                  key={sublink.to}
                />
              );
            })}
          </Tabs>
        )}
        {this.state.activeSubLink === "/user/interested-programs/all" && (
          <Tabs
            value={
              this.state.activeSubSubLink ||
              this.sublinks["/user/interested-programs"][0].submenu?.[0]?.to ||
              ""
            }
            onChange={(event, newValue) => {
              this.setState({ activeSubSubLink: newValue });
              this.props.history.push(newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="third level submenu"
            TabIndicatorProps={{ className: this.props.classes.tabIndicator }}
            classes={{ root: this.props.classes.subHeadings }}
          >
            {this.sublinks["/user/interested-programs"][0].submenu?.map(
              subSubItem => (
                <Tab
                  label={subSubItem.name}
                  value={subSubItem.to}
                  disableRipple
                  disableFocusRipple
                  classes={{
                    root: `${this.props.classes.tabRoot} ${this.props.classes.subMenuText}`,
                    selected: this.props.classes.tabSelected
                  }}
                  key={subSubItem.to}
                />
              )
            )}
          </Tabs>
        )}
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(ParentNav));
